











































































































import { Component, Mixins, Ref } from 'vue-property-decorator';
import NavigationCard from '@/NavigationCard';
import RequestButton from '@/RequestButton';
import SelectionBlock from '@/SelectionBlock';
import InitData from 'src/mixin/initData';
import { CommonRes } from 'src/types/views/common';
import { LocalIndustryItem, IndustryItem } from 'src/types/views/home';
import { SB } from 'src/types/components/selection';

@Component({
  components: { NavigationCard, RequestButton, SelectionBlock },
})
export default class OrganizationList extends Mixins(InitData) {
  @Ref('s1') readonly s1!: SelectionBlock & SB;

  @Ref('s2') readonly s2!: SelectionBlock & SB;

  @Ref('s3') readonly s3!: SelectionBlock & SB;

  @Ref('s4') readonly s4!: SelectionBlock & SB;

  data: LocalIndustryItem[] = [];

  url = 'SearchOrganization/search';

  pageSize = 24;

  queryParam = {
    firstType: '',
    secondType: '',
    firstServiceType: '',
    secondServiceType: '',
    province: '',
    city: '',
    downtown: '',
    serviceProvince: '',
    serviceCity: '',
    serviceDowntown: '',
  };

  beforeInit() {
    const { queryParam } = this;
    this.params = {
      pageNum: this.pageNum,
      pageSize: this.pageSize,
      word: this.keyword,
      wholews: this.wholews,
      servicetype: queryParam.secondType || queryParam.firstType || '',
      serviceindustry: queryParam.secondServiceType || queryParam.firstServiceType || '',
      provincew: queryParam.province,
      cityw: queryParam.city,
      downtownw: queryParam.downtown,
      province: queryParam.serviceProvince,
      city: queryParam.serviceCity,
      downtown: queryParam.serviceDowntown,
    };
    return true;
  }

  clear() {
    this.s1.cancelFirstType();
    this.s2.cancelFirstType();
    this.s3.cancelFirstType();
    this.s4.cancelFirstType();
  }

  toDetail(name: string, id: string) {
    this.$router.push({
      name,
      query: { id },
    });
  }

  afterInit(res: CommonRes<IndustryItem>) {
    this.data = res.data.rows.map(item => ({
      name: item.name,
      area: item.serviceareaname,
      url: item.logo,
      industry: item.serviceindustryname
        .replace(/[(（].*?[)）]/g, '')
        .split(/[,，]/)
        .sort((a: string, b: string) => a.length - b.length)
        .slice(0, 2),
      description: item.description.replace(/<[^>]+>|&nbsp;|\s+/g, ''),
      id: item.id,
    }));
    this.total = res.data.count || 0;
    return true;
  }

  changeFirstType(id: string) {
    this.queryParam.firstType = id;
    this.queryParam.secondType = '';
    this.toQuery();
  }

  changeSecondType(id: string) {
    this.queryParam.secondType = id;
    this.toQuery();
  }

  changeFirstServiceType(id: string) {
    this.queryParam.firstServiceType = id;
    this.queryParam.secondServiceType = '';
    this.toQuery();
  }

  changeSecondServiceType(id: string) {
    this.queryParam.secondServiceType = id;
    this.toQuery();
  }

  changeProvince(id: string) {
    this.queryParam.province = id;
    this.queryParam.city = '';
    this.queryParam.downtown = '';
    this.toQuery();
  }

  changeCity(id: string) {
    this.queryParam.city = id;
    this.queryParam.downtown = '';
    this.toQuery();
  }

  changeDowntown(id: string) {
    this.queryParam.downtown = id;
    this.toQuery();
  }

  changeServiceProvince(id: string) {
    this.queryParam.serviceProvince = id;
    this.queryParam.serviceCity = '';
    this.queryParam.serviceDowntown = '';
    this.toQuery();
  }

  changeServiceCity(id: string) {
    this.queryParam.serviceCity = id;
    this.queryParam.serviceDowntown = '';
    this.toQuery();
  }

  changeServiceDowntown(id: string) {
    this.queryParam.serviceDowntown = id;
    this.toQuery();
  }
}
